// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12S4M","footer":"styles_footer__2_1Ir"};